module.exports = {"Open Die/Hand Forging":"Open Die/Hand Forging","Closed Die Forging":"Closed Die Forging","EDMtool Die":"EDMtool Die","Rolled Ring":"Rolled Ring","Impression Die":"Impression Die","Cold Forging":"Cold Forging","Upset Forging":"Upset Forging","Cold Warm":"Cold Warm","Mechanical Power":"Mechanical Power","Ship Boat Shipshaft":"Ship Boat Shipshaft"}


//////////////////
// WEBPACK FOOTER
// ./src/config/forgingProcess.json
// module id = 5410
// module chunks = 1